export default __webpack_public_path__ + "static/media/kuruah-logo.08487746.svg";